// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'Cormorant', 'Cormorant Fallback'","fontStyle":"normal"},"className":"__className_5dd834","variable":"__variable_5dd834"};